// extracted by mini-css-extract-plugin
export default {"box":"index_box_gdLog","hongbaoBox":"index_hongbaoBox_G-y5M","close":"index_close_mLvoi","image":"index_image_h65S7","tada":"index_tada_J7-GF"};